import { render, staticRenderFns } from "./CommentModeration.vue?vue&type=template&id=00004dd0&scoped=true"
import script from "./CommentModeration.vue?vue&type=script&lang=js"
export * from "./CommentModeration.vue?vue&type=script&lang=js"
import style0 from "./CommentModeration.vue?vue&type=style&index=0&id=00004dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00004dd0",
  null
  
)

export default component.exports